import Cathy from '../../pages/cathy/Cathy'

import PrefixEnum from '../prefixes'

export default Object.freeze([
    { path: PrefixEnum.CATHY_HUMMELS, component: Cathy },
])
